import "./CustomSelect.scss";

import React, { memo, useMemo, useState } from "react";

import { Select } from "antd";
import PropTypes from "prop-types";

import { pluralizeNoun } from "../../Utils/utilityFunctions";

const CustomSelect = ({
  mode,
  itemsList,
  item,
  renderOptions,
  onSelectItem,
  itemTitle = "",
  hasSelectAll = true,
  isSearchable = true,
  placeholder = "",
  className = "",
  status,
  ...props
}) => {
  const [searchQuery, setSearchQuery] = useState("");

  const onSearchItem = (value) => {
    setSearchQuery(value);
  };

  const filteredItems = useMemo(() => {
    if (!itemsList) return [];

    if (!isSearchable) return itemsList;

    return [
      ...(hasSelectAll
        ? [
            {
              _id: null,
              title: `All ${pluralizeNoun(itemTitle?.toLowerCase())}`,
            },
          ]
        : []),
      ...itemsList,
    ].filter((each) =>
      each?.title?.toLowerCase().includes(searchQuery.toLowerCase())
    );
  }, [itemsList, searchQuery, isSearchable, hasSelectAll, itemTitle]);

  return (
    <Select
      mode={mode}
      className={`custom-select ${className} ${
        status ? `custom-select--${status}` : ""
      }`}
      placeholder={placeholder || `Select ${itemTitle?.toLowerCase()}`}
      size="large"
      showSearch={isSearchable}
      filterOption={false}
      defaultActiveFirstOption
      searchValue={searchQuery}
      value={item}
      onSearch={onSearchItem}
      onChange={onSelectItem}
      options={
        renderOptions
          ? renderOptions(filteredItems)
          : filteredItems.map((each) => ({
              label: each.title,
              value: each._id,
            }))
      }
      notFoundContent={`No ${pluralizeNoun(itemTitle)?.toLowerCase()} found`}
      {...props}
    />
  );
};
CustomSelect.propTypes = {
  mode: PropTypes.string,
  itemsList: PropTypes.shape().isRequired,
  item: PropTypes.shape(),
  renderOptions: PropTypes.func,
  onSelectItem: PropTypes.func.isRequired,
  itemTitle: PropTypes.string,
  hasSelectAll: PropTypes.bool,
  isSearchable: PropTypes.bool,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  status: PropTypes.string,
  [PropTypes.string]: PropTypes.shape(),
};

export default memo(CustomSelect);
